// paymentReducer.js
import {
    FETCH_FEE_PAYMENT_REQUEST,
    FETCH_FEE_PAYMENT_SUCCESS,
    FETCH_FEE_PAYMENT_FAILURE,
  } from '../actions/FeeActionTypes';
  
  const initialState = {
    loading_payments: false,
    payments: [],
    error: '',
  };
  
  const paymentReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_FEE_PAYMENT_REQUEST:
        return {
          ...state,
          loading_payments: true,
        };
      case FETCH_FEE_PAYMENT_SUCCESS:
        return {
          loading_payments: false,
          payments: action.payload,
          error: '',
        };
      case FETCH_FEE_PAYMENT_FAILURE:
        return {
          loading_payments: false,
          payments: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default paymentReducer;
  